<template>

<div class="summary">

	<div class="summary-icon"></div>

	<app-text v-if="recommendation.summary.enabled === $constants.recommendation.text.text" :text="recommendation.summary.text" />

	<app-blocks v-if="recommendation.summary.enabled === $constants.recommendation.text.blocks" :text="recommendation.summary.blocks" />

</div>

</template>

<script>

export default {

	props: ['recommendation']

}

</script>

<style scoped>

.summary {
	margin-bottom: 64px;
	background-color: #343434;
	border-radius: 73px;
	padding: 32px 32px 32px 136px;
	min-height: 136px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.summary-icon {
	position: absolute;
	left: 16px;
	top: 16px;
	width: 104px;
	height: 104px;
	background-color: var(--primary-color);
	mask-image: url(~@/assets/recommendation.summary.svg);
	background-position: 16px 16px;
	background-repeat: no-repeat;
}

.is-mobile .summary-icon {
	width: 48px;
	height: 48px;
	mask-size: contain;
	background-position: 50% 50%;
	background-repeat: no-repeat;
}

.is-mobile .summary {
	padding: 80px 15px 15px 15px;
	background-position: 50% 16px;
	background-size: auto 48px;
	border-radius: 20px;
	min-height: 0px;
	margin-bottom: 32px;
}

.summary >>> p,
.summary >>> li {
	color: #fff!important;
	font-weight: 400!important;
	font-size: 20px!important;
}

.summary >>> b,
.summary >>> strong {
	font-weight: 600!important;
}

.is-mobile .summary >>> p,
.is-mobile .summary >>> li {
	font-size: 14px!important;
	line-height: 18px!important;
}

</style>